<div id="error-503" class="flex-column-center-center">
  <div class="content mb-24 mt-32 flex-column-center-center">
    <div class="error-code">503</div>

    <div class="message">{{ "ERROR_503.MESSAGE" | translate }}</div>

    <div class="sub-message">
      {{ "ERROR_503.SUB_MESSAGE" | translate }}
      <!-- <div *ngIf="last503URL">{{ last503URL }}</div> -->
    </div>

    <div class="humor-tip mb-16">
      {{ "ERROR_503.HUMOR_TIP" | translate }}
    </div>

    <div class="my-12 flex-row-center-center">
      <button
        mat-raised-button
        color="accent"
        [disabled]="isChecking"
        (click)="onRetry()"
      >
        <i
          *ngIf="isChecking"
          class="fa fa-spinner fa-spin mr-8"
        ></i>
        {{ "ERROR_503.RETRY" | translate }}
      </button>
    </div>

    <div class="auto-check-info mb-8">
      {{ "ERROR_503.AUTO_CHECK" | translate }}
    </div>

    <a class="report-link" (click)="onVisitGt2()">{{
      "ERROR_503.GT2_SITE" | translate
    }}</a>

    <div class="flex-row-center-center">
      <div class="p-8 mat-caption 8">Version: {{ environment.appVersion }}</div>
    </div>
  </div>

  <!--<div class="content mb-24" class="flex-column-center-center">-->
  <!--<div class="sub-message">-->
  <!--{{ 'ERROR_503.SUB_MESSAGE' | translate }}-->
  <!--</div>-->

  <!--&lt;!&ndash;<a class="back-link mt-8" (click)="onPageBack()">{{ 'ERROR_503.BACK_PAGE' | translate }}</a>&ndash;&gt;-->
  <!--<a class="report-link" (click)="onPageBack()">{{ 'ERROR_503.BACK_PAGE' | translate }}</a>-->
  <!--&lt;!&ndash;<a class="report-link" [routerLink]="'/tableau-de-bord'">{{ 'ERROR_503.REPORT_PROBLEM' | translate }}</a>&ndash;&gt;-->
  <!--</div>-->

  <!-- <div class="content-form mb-32 flex-column-center-center">
    <mat-card class="content-form-card" style="width: 100%">
      <mat-card-header
        style="margin-left: 16px !important; margin-top: 8px !important"
      >
        <mat-card-title class="title-card">{{
          "ERROR_503.CONTACT_US" | translate
        }}</mat-card-title>
        <mat-card-subtitle *ngIf="translate.currentLang === 'fr-CA'"
          >Demande de ticket :
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="translate.currentLang === 'en-CA'"
          >Ticket request:
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div class="flex-row-center-center">
          <div class="p-8 mat-caption 8">
            Version: {{ environment.appVersion }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div> -->
</div>
